<template>
  <div class="w-full h-full">
    <div class="relative flex flex-col w-full h-full">
      <two-blocks-layout :navigate="navigate" v-bind="page" class="my-auto">
        <span class="text-outline text-title-md" v-text="`${page.titolo1} `" />
        <span class="text-title-md " v-text="page.titolo2" />
        <template #right>
          <video-gallery v-bind="page" class="w-full" />
        </template>
      </two-blocks-layout>
      <app-cta-button
        cta
        mobile-only
        full-width
        :link="apriContoUrl"
        external
      />
    </div>
  </div>
</template>

<script>
import { axios } from "@/plugins/axios";
import TwoBlocksLayout from "@/components/page-layouts/TwoBlocksLayout.vue";
import VideoGallery from "@/components/VideoGallery.vue";

export default {
  components: { VideoGallery, TwoBlocksLayout },
  props: { navigate: { default: null } },
  async beforeRouteEnter(to, from, next) {
    let page;
    try {
      page = await axios.get(`/pageContent${to.path}.json`);
    } catch (error) {
      page = {};
    } finally {
      next(vm => (vm.page = page.data));
    }
  }
};
</script>

<route>
{
  "name": "Tuttorial",
  "meta": {
    "order": 8,
    "label": "Tuttorial",
    "hideMenu": {
      "inline": true
    }
  }
}
</route>
